module.exports = __webpack_public_path__ + "static/game-changer-18fcaa88232414252f74d742b3e92e26.jpg";